import { DATA_TYPE_CODE } from '~/web-frontend-core/api/const/base';
import { BaseSocketConnector } from '~/web-frontend-core/api/connector/BaseSocketConnector';
export default class LiveOutcomes extends BaseSocketConnector {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.LIVE_OUTCOMES_TABLE;
    }
    getOutcomeData(cfg) {
        var _a, _b;
        return {
            site: this.siteType,
            lng: this.language,
            timezone: this.timezone,
            id: ((_b = (_a = cfg) === null || _a === void 0 ? void 0 : _a.matchIds) === null || _b === void 0 ? void 0 : _b[0]) || cfg.id,
        };
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/outcomes/Base.js